export default __webpack_public_path__ + "static/media/PT-Root-UI_Medium.942457a3.woff2";